// extracted by mini-css-extract-plugin
export default {"title":"Hall_title__-Dsde","gallery":"Hall_gallery__fso0S","list":"Hall_list__Jj6-R","comment":"Hall_comment__y7i3l","addButton":"Hall_addButton__uIiWi"};